import React, { FC, useCallback } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import { useSelector, useDispatch } from 'react-redux'
import { useDropzone } from 'react-dropzone'

import Grid from '@mui/material/Grid'
import HelperText from '@kaidam/fc-shared/src/frontend/components/form/fields/HelperText'

import {
  IField_Storage_File,
} from '@kaidam/fc-shared/src/types/storage'

import TinyButton from '../widgets/TinyButton'
import UploadStatus from '../uploader/UploadStatus'

import fileuploadActions from '../../store/modules/fileupload'
import fileuploadSelectors from '../../store/selectors/fileupload'

import {
  ThunkDispatcher,
} from '../../types/store'

import icons from '../../icons'

const UploadIcon = icons.upload

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  cell: {
    flexGrow: 1,
  },
  image: {
    maxWidth: '200px',
    border: '1px solid #000',
  },
  editIcon: {
    marginRight: theme.spacing(1),
  },
  buttonTitle: {
    display: 'inline-block',
    paddingRight: '10px',
  },
  buttonIcon: {
    width: '20px',
    height: '20px',
  },
  button: {
    margin: theme.spacing(1),
  },
  info: {
    display: 'flex',
    flexDirection: 'row',
  },
  intro: {
    marginRight: theme.spacing(2),
  },
  imageContainer: {
    marginTop: theme.spacing(2),
  },
  filepath: {
    //marginTop: theme.spacing(2),
  }
}))

const FileUploader: FC<React.PropsWithChildren<{
  token: string,
  path: string,
  onUpload: (files: IField_Storage_File[]) => void,
}>> = ({
  token,
  path,
  onUpload,
}) => {

  const classes = useStyles()
  const dispatch = useDispatch()
  const thunkDispatch = dispatch as ThunkDispatcher
  const uploadInProgress = useSelector(fileuploadSelectors.inProgress)
  const uploadStatus = useSelector(fileuploadSelectors.status)
  const uploadError = useSelector(fileuploadSelectors.network.uploadFiles.error)

  const {
    getRootProps,
    getInputProps,
    inputRef,
  } = useDropzone({
    onDrop: async (files) => {
      if(files.length <= 0) return
      const result = await thunkDispatch(fileuploadActions.uploadBookingFile({
        files,
        token,
        path,
      }))
      if(!result) return
      onUpload(result)
    },
    multiple: true,
  })

  const onOpenUploader = useCallback(() => {
    if(!inputRef.current) return
    inputRef.current.click()
  }, [])

  return uploadInProgress ? (
    <div className={ classes.container }>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <UploadStatus
            error={ uploadError }
            status={ uploadStatus }
          />
        </Grid>
      </Grid>
    </div>
  ) : (
    <>
      <div className={ classes.container }>
        <div className={ classes.cell }>
          <TinyButton
            
            variant="contained"
            size="small"
            onClick={ onOpenUploader }
            className={ classes.button }
          >
            Upload&nbsp;&nbsp;&nbsp;<UploadIcon className={ classes.buttonIcon } />
          </TinyButton>
        </div>
      </div>
      <div {...getRootProps()}>
        <input {...getInputProps()} />
      </div>
      {
        uploadError && (
          <HelperText 
            helperText={ uploadError }
            error
            touched
          />
        )
      }
    </>
  )
}

export default FileUploader